module.exports = __webpack_public_path__ + "assets/img/impression-bouton.ebc97dc0.jpg";